<template>
  <div class="version-display">
    <span>v{{ version }}</span>
  </div>
</template>

<script>
export default {
  name: 'VersionDisplay',
  data() {
    return {
      version: process.env.VUE_APP_VERSION || '1.0.0'
    }
  }
}
</script>

<style scoped>
.version-display {
  font-size: 0.8em;
  color: #666;
  padding: 4px 8px;
  background-color: #f5f5f5;
  border-radius: 4px;
  display: inline-block;
}
</style> 